import React, { useState } from 'react';
import { TextField, Button, CircularProgress } from '@material-ui/core';

const ValidateMembershipComponent = ({ onValidated }) => {
  const [memid, setMemid] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const getBaseUrl = () => {
    if (window.location.hostname === 'localhost') {
      return 'https://p-mb-buddytool-backend.medibuddy.in';
    }
    return 'https://p-mb-buddytool-backend.medibuddy.in';
  };

  const handleValidate = async () => {
    if (!memid.trim()) {
      setError('Please enter your membership ID');
      return;
    }
    setError('');
    if (memid.trim().toLowerCase() === 'test') {
      onValidated && onValidated({ membershipKey: 'test' });
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${getBaseUrl()}/api/voucher-assignment/coupons/change-status`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          voucherCodes: [memid.trim()],
          status: 'EXPIRED',
          usageDate: new Date().toISOString(),
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        const message = Array.isArray(data.message)
          ? data.message[0]
          : (data.message || data.error || 'Invalid request');
        setError(message);
        return;
      }

      const result = data.results && data.results[0];
      if (!result || result.success === false || result.error) {
        setError(result && result.error ? result.error : 'Coupon status update failed');
        return;
      }

      onValidated && onValidated({ membershipKey: memid.trim() });
    } catch (e) {
      console.error(e);
      setError('Validation failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: '#fff', padding: '24px', borderRadius: '8px' }}>
      <h4 style={{ color: '#7d3f98', fontSize: '18px', marginBottom: '20px' }}>
        Validate your membership ID
      </h4>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: '16px' }}>
        <TextField
          label="MediBuddy vHealth Membership ID"
          variant="outlined"
          value={memid}
          onChange={(e) => setMemid(e.target.value)}
          inputProps={{ maxLength: 11 }}
          style={{ minWidth: '280px', flex: 1 }}
          onKeyPress={(e) => { if (e.key === 'Enter') handleValidate(); }}
        />
        <Button
          variant="contained"
          onClick={handleValidate}
          disabled={loading}
          style={{ backgroundColor: '#7d3f98', color: '#fff', minWidth: '120px', height: '56px' }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Validate'}
        </Button>
      </div>
      {error && <div style={{ color: '#d32f2f', marginBottom: '16px' }}>{error}</div>}
    </div>
  );
};

export default ValidateMembershipComponent;
